// extracted by mini-css-extract-plugin
export default {"container":"DropdownLabel_container__wjph9","disabled":"DropdownLabel_disabled__2vt-c"};